export default __webpack_public_path__ + "img/server.e5c10cc.svg";